import React from "react";
import { Layout } from "antd";

const { Footer } = Layout;

export default function MainFooter() {
  return (
    <Footer
      style={{
        textAlign: "center",
        padding: 10,
        margin: "auto",
      }}>
      Powip ©2023
    </Footer>
  );
}
